var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", {}, [
      _c(
        "section",
        { staticClass: "container-fluid middle-section territory-page" },
        [
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("multiselect", {
                  attrs: {
                    name: "marketSegment",
                    id: "marketSegment",
                    label: "key",
                    options: _vm.pinFilter,
                    multiple: false,
                    taggable: true,
                    "track-by": "key",
                    selectLabel: "",
                    deselectLabel: "",
                    selectedLabel: "",
                    hideSelected: false,
                    placeholder: "Market Segment"
                  },
                  on: { input: _vm.inputPinFilter },
                  model: {
                    value: _vm.pinApply,
                    callback: function($$v) {
                      _vm.pinApply = $$v
                    },
                    expression: "pinApply"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-8" },
              [_c("vue-table-dynamic", { attrs: { params: _vm.params } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-10" }, [
              _c("ul", { staticClass: "mapping-filter" }, [
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "marketSegment",
                        id: "marketSegment",
                        label: "name",
                        options: _vm.marketSegmentArr,
                        multiple: false,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "Market Segment"
                      },
                      model: {
                        value: _vm.marketSegment,
                        callback: function($$v) {
                          _vm.marketSegment = $$v
                        },
                        expression: "marketSegment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "manufacturer",
                        id: "manufacturer",
                        label: "name",
                        options: _vm.manufacturerArr,
                        multiple: true,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "Manufacturer"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection",
                          fn: function(ref) {
                            var values = ref.values
                            var search = ref.search
                            return [
                              values.length
                                ? _c(
                                    "span",
                                    { staticClass: "multiselect__single" },
                                    [
                                      _vm._v(
                                        _vm._s(values.length) +
                                          " Manufacturer selected\n                                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.manufacturer,
                        callback: function($$v) {
                          _vm.manufacturer = $$v
                        },
                        expression: "manufacturer"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "pma",
                        id: "pma",
                        label: "name",
                        options: _vm.pmaArr,
                        multiple: false,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "PMA"
                      },
                      on: { input: _vm.changedValuePMA },
                      model: {
                        value: _vm.pma,
                        callback: function($$v) {
                          _vm.pma = $$v
                        },
                        expression: "pma"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticStyle: { "min-width": "200px" } },
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "lga",
                        id: "lga",
                        label: "name",
                        options: _vm.lgaArr,
                        multiple: true,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        "close-on-select": false,
                        "option-height": 50,
                        placeholder: "LGA"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection",
                          fn: function(ref) {
                            var values = ref.values
                            var search = ref.search
                            return [
                              values.length
                                ? _c(
                                    "span",
                                    { staticClass: "multiselect__single" },
                                    [
                                      _vm._v(
                                        _vm._s(values.length) +
                                          " LGA selected\n                                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.lga,
                        callback: function($$v) {
                          _vm.lga = $$v
                        },
                        expression: "lga"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "fromMonth",
                        id: "fromMonth",
                        label: "name",
                        options: _vm.fromMonthArr,
                        multiple: false,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "From Month"
                      },
                      model: {
                        value: _vm.fromMonth,
                        callback: function($$v) {
                          _vm.fromMonth = $$v
                        },
                        expression: "fromMonth"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "fromYear",
                        id: "fromYear",
                        label: "year",
                        options: _vm.fromYearArr,
                        multiple: false,
                        taggable: true,
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "From Year",
                        disabled: _vm.fromMonth == "" || _vm.fromMonth == null
                      },
                      model: {
                        value: _vm.fromYear,
                        callback: function($$v) {
                          _vm.fromYear = $$v
                        },
                        expression: "fromYear"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "toMonth",
                        id: "toMonth",
                        label: "name",
                        options: _vm.fromMonthArr,
                        multiple: false,
                        taggable: true,
                        "track-by": "id",
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "To Month"
                      },
                      model: {
                        value: _vm.toMonth,
                        callback: function($$v) {
                          _vm.toMonth = $$v
                        },
                        expression: "toMonth"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c("multiselect", {
                      attrs: {
                        name: "toYear",
                        id: "toYear",
                        label: "year",
                        options: _vm.toYearArr,
                        multiple: false,
                        taggable: true,
                        selectLabel: "",
                        deselectLabel: "",
                        selectedLabel: "",
                        hideSelected: false,
                        placeholder: "To Year",
                        disabled: _vm.toMonth == ""
                      },
                      model: {
                        value: _vm.toYear,
                        callback: function($$v) {
                          _vm.toYear = $$v
                        },
                        expression: "toYear"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "postal-code" }, [
                _c(
                  "button",
                  {
                    staticClass: "search-btn",
                    on: { click: _vm.searchResult }
                  },
                  [_vm._v("Search")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-9 map-container" },
              [
                _c("gmap", {
                  attrs: { gmapmarkers: _vm.mapmarkers, soldUnit: _vm.soldUnit }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "table",
                { staticClass: "table table-bordered table-striped" },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      {
                        staticClass: "table-primary",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c("th", [_vm._v("Total")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm.total != 0
                            ? _c("div", { staticClass: "page-name" }, [
                                _vm._v(_vm._s(_vm.total))
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-wrapper-scroll-y",
                  staticStyle: { height: "65vh", overflow: "auto" }
                },
                [
                  _c(
                    "table",
                    { staticClass: "table table-bordered table-striped mb-0" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm.statistics && _vm.statistics.length > 0
                            ? _vm._l(_vm.statistics, function(data, index) {
                                return _c("tr", { key: index }, [
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.titleCase(data.name)))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              (data.count / _vm.total) * 100
                                            ).toFixed(2)
                                          ) + "%"
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { "text-align": "right" } },
                                    [_c("span", [_vm._v(_vm._s(data.count))])]
                                  )
                                ])
                              })
                            : [_vm._m(2)]
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "page-loader-wrapper loading-container",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/static/images/loading.gif" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        {
          staticClass: "table-primary",
          staticStyle: { "text-align": "center" }
        },
        [
          _c("th", [_vm._v("Manufacturer")]),
          _vm._v(" "),
          _c("th", [_vm._v("Market Share")]),
          _vm._v(" "),
          _c("th", [_vm._v("Count")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "3", align: "center" } }, [
        _vm._v("No data!!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bd83fe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd83fe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales/salesoverview.vue
// module id = null
// module chunks = 